import script from "./FiltersPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltersPopup.vue?vue&type=script&setup=true&lang=js"

import "./FiltersPopup.vue?vue&type=style&index=0&id=18af8382&lang=css"

const __exports__ = script;

export default __exports__